import { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "@/data/content";
import { useDiagnostic } from "./DiagnosticContext";

export const Nav = () => {
  const { open } = useDiagnostic();
  const [menu, setMenu] = useState(false);
  return (
    <header data-testid="nav-header" className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-[68px] max-w-[1360px] items-center justify-between gap-6 px-5 lg:px-10">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.href.slice(1)}`}
              className="relative text-[14px] font-medium text-slate-700 transition-colors hover:text-[#0E9384] after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-0 after:bg-[#14B8A6] after:transition-[width] after:duration-300 hover:after:w-full">
              {l.label}
            </a>
          ))}
        </nav>
        <button data-testid="nav-cta-btn" onClick={() => open()}
          className="btn-teal hidden items-center gap-2 rounded-lg px-5 py-3 text-[14px] font-semibold md:flex">
          Find My AI Project Starting Point <ArrowRight className="arrow h-4 w-4" />
        </button>
        <button data-testid="nav-menu-toggle" onClick={() => setMenu(!menu)} className="rounded-md p-2 text-[#0B1B33] lg:hidden" aria-label="Menu">
          {menu ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {menu && (
        <div data-testid="nav-mobile-menu" className="border-t border-slate-200 bg-white px-5 pb-5 lg:hidden">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMenu(false)} className="block border-b border-slate-100 py-3 text-[15px] font-medium text-slate-800">{l.label}</a>
          ))}
          <button data-testid="nav-mobile-cta-btn" onClick={() => { setMenu(false); open(); }}
            className="btn-teal mt-4 flex w-full items-center justify-center gap-2 rounded-lg px-5 py-3 text-[15px] font-semibold">
            Find My AI Project Starting Point <ArrowRight className="arrow h-4 w-4" />
          </button>
        </div>
      )}
    </header>
  );
};
